import React from "react";
import { ApiError, getApiErrorId } from "../api/authApiClient";
import { FormattedError } from "./FormattedError";

interface AlertsWrapperProps {
  errors: ApiError[];
  messages: string[];
  children: React.ReactNode;
}

/* Visually wrap children and display error and success messages */
export const AlertsWrapper = ({
  children,
  errors,
  messages,
}: AlertsWrapperProps) => {
  return (
    <div>
      <Errors errors={errors} />
      <Messages messages={messages} />
      {children}
    </div>
  );
};

const Errors = ({ errors }: { errors: ApiError[] }) =>
  errors.length > 0 && (
    <ul data-testid="flash-errors" className="mb-3 space-y-4">
      {errors.map((error: ApiError) => {
        return (
          <li
            className="rounded-md bg-red-100 p-3 px-4 text-sm font-medium text-red-700"
            key={getApiErrorId(error)}
          >
            <FormattedError error={error} />
          </li>
        );
      })}
    </ul>
  );

const Messages = ({ messages }: { messages: string[] }) =>
  messages.length > 0 && (
    <div
      data-testid="flash-messages"
      className="mb-3 rounded-md bg-green-100 p-3"
    >
      {messages.map((message: string) => (
        <div className="text-sm font-medium text-green-700" key={message}>
          {message}
        </div>
      ))}
    </div>
  );
